var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 7.49996V4.99996C12.3335 3.15901 10.8411 1.66663 9.00015 1.66663C7.1592 1.66663 5.66681 3.15901 5.66681 4.99996V7.49996M1.99348 8.6266L1.49348 13.9599C1.35132 15.4763 1.28023 16.2346 1.53185 16.8202C1.75289 17.3347 2.14024 17.76 2.63183 18.0281C3.19142 18.3333 3.95295 18.3333 5.47602 18.3333H12.5243C14.0473 18.3333 14.8089 18.3333 15.3685 18.0281C15.86 17.76 16.2474 17.3347 16.4684 16.8202C16.7201 16.2346 16.649 15.4763 16.5068 13.9599L16.0068 8.6266C15.8868 7.34608 15.8267 6.70582 15.5388 6.22176C15.2851 5.79545 14.9104 5.45422 14.4623 5.2415C13.9535 4.99996 13.3104 4.99996 12.0243 4.99996L5.97602 4.99996C4.68989 4.99996 4.04682 4.99996 3.53799 5.24149C3.08987 5.45422 2.71515 5.79545 2.46153 6.22176C2.17355 6.70582 2.11353 7.34608 1.99348 8.6266Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.15b8fb7838dfb2eccbcfc4e890706445.svg";
export { ForwardRef as ReactComponent };